import React from 'react';
import { ContextWidget } from '../../types/api/Widget';
import { WidgetType } from '../../types/api/ElementType';
import { Icons } from '../../components/atoms/SVG';
import { ConfigurationAggregateBlock } from '../../_blocks/ConfigurationAggregate/ConfigurationAggregateBlock';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { CompositionConfigurationBlock } from '../../_blocks/CompositionConfiguration/CompositionConfigurationBlock';
import { PluginConfigurationBlock } from '../../_blocks/PluginConfiguration/PluginConfigurationBlock';
import { DefaultContextWidget } from '../_utils/asDefaultWidget';
import { RolePrivilegeConfigBlock } from '../../_blocks/RolePrivilegeConfig/RolePrivilegeConfigBlock';

type PortalSettingImportExportBlocks =
  ConfigurationAggregateBlock | CompositionConfigurationBlock | PluginConfigurationBlock | RolePrivilegeConfigBlock;
export type PortalSettingImportExportWidget = ContextWidget<
  PortalSettingImportExportBlocks,
  WidgetType.portalsettingimportexport
>;

export function PortalSettingImportExportWidget(props: PortalSettingImportExportWidget) {
  const { t } = useSonTranslation('PortalSettingImportExport');
  return <DefaultContextWidget icon={Icons.CONFIG_FILE} title={t('widgetTitle')} {...props} />;
}
